import ExoTable from '../exo/ExoTable';
import { Box, Typography } from '@mui/material';
import MoneyLabel from '../label/MoneyLabel';
import { useTranslation } from 'react-i18next';
import useFetch from '../../api/useFetch';
import DateLabel from '../label/DateLabel';

export const SelectPendingPayment = ({
  filter,
  onSelect,
  apiUrl,
  hasOpenAmount,
}) => {
  const { t } = useTranslation();

  // can add search functionality later if needed
  // const [searchResults, setSearchResults] = useState(null);
  // console.log(searchResults, 'searchResults in select receipt');

  const { apiData } = useFetch(apiUrl || `payment-reminder?${filter}`); // change to pending payments endpoint when available

  const Columns = [
    {
      header: 'Nr', // header of column
      key: 'nr', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      width: '100px', // width of column
      cell: ({ row }) => (
        <Box className="monospace whitespace-nowrap">
          {row.dunningProcess.invoice?.nr}
        </Box>
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => onSelect(row),
    },
    {
      header: t('Invoice Title'), // header of column
      key: 'title', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      onClick: (row) => onSelect(row),
      cell: ({ row }) => (
        <Box className="monospace whitespace-nowrap">
          {row.dunningProcess.invoice?.title}
        </Box>
      ),
    },
    {
      header: t('Title'), // header of column
      key: 'title', // key of column in row-object
      thAlign: 'left', // header text alignment
      tdAlign: 'left', // cell text alignment
      sortable: true, // enable sort function for column
      onClick: (row) => onSelect(row),
    },

    {
      header: t('Date'), // header of column
      key: 'newDeadline', // key of column in row-object
      thAlign: 'right', // header text alignment
      tdAlign: 'right', // cell text alignment
      sortable: true, // enable sort function for column
      width: '120px', // width of column
      cell: ({ row }) => (
        <Box className="monospace">
          <DateLabel date={row.createdAt} />
        </Box>
      ), // custom xml for cells in the column. you get the row as object
      hiddenMobile: true, // hides the column on mobile
      onClick: (row) => onSelect(row),
    },
    {
      header: t('Open'), // header of column
      key: 'openAmount', // key of column in row-object
      thAlign: 'right', // header text alignment
      tdAlign: 'right', // cell text alignment
      width: '200px', // width of column
      hiddenMobile: !hasOpenAmount, // hides the column on mobile
      hiddenDesktop: !hasOpenAmount, // hides the column on desktop
      cell: ({ row }) => (
        <Typography className=" monospace">
          <MoneyLabel money={row.openAmount} />
        </Typography>
      ), // custom xml for cells in the column. you get the row as object
      onClick: (row) => onSelect(row),
    },
  ];
  return (
    // <DBSearch
    //   param={'invoices'}
    //   onSearch={(res) => setSearchResults({ data: res })}
    // >
    <ExoTable
      data={apiData}
      columns={Columns}
      isLoading={!apiData}
      className="h-full w-full"
    />
    // </DBSearch>
  );
};
